import { createAction } from '@ngrx/store';

export const CompleteOrderLoadDeliveryStep = createAction(
  '[GA Complete Order] Load Delivery Step'
);

export const CompleteOrderLoadPaymentStep = createAction(
  '[GA Complete Order] Load Payment Step'
);

export const CompleteOrderLoadDirectDebitStep = createAction(
  '[GA Complete Order] Load Direct Debit Step'
);

export type CompleteOrderActions =
  | typeof CompleteOrderLoadDeliveryStep
  | typeof CompleteOrderLoadPaymentStep
  | typeof CompleteOrderLoadDirectDebitStep;
